import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IReflectiveAnalysisQuestion, IReflectiveAnalysisResource } from "../types";

export interface IReflectiveAnalysisUpdateMutationParameters {
    reflectiveAnalysis: RelationalValue<IReflectiveAnalysisResource>;
    data: {
        questions: IReflectiveAnalysisQuestion[];
    };
}

export type IReflectiveAnalysisUpdateMutationResult = IReflectiveAnalysisResource;

export const reflectiveAnalysisUpdateMutation: IApiMutationFunction<IReflectiveAnalysisUpdateMutationParameters> = ({
    reflectiveAnalysis,
    data: { questions },
}) => {
    return {
        method: "PUT",
        url: `/reflective_analyses/${mapRelationalValue(reflectiveAnalysis)}`,
        data: {
            questions,
        },
    };
};

export const useReflectiveAnalysisUpdateMutation = createApiMutationHook<
    IReflectiveAnalysisUpdateMutationParameters,
    IReflectiveAnalysisUpdateMutationResult
>(reflectiveAnalysisUpdateMutation);
